import React from 'react';
import PropTypes from 'prop-types';
import CurrencyHelper, { currencyIsoCodes } from '../../../general/js/basket/currency-helper';
import gtm, { ecommerceEventTypes } from '../../../general/js/gtm';
import TrackingHelper from '../../../general/js/basket/tracking-helper';
import { withTicketBuilderContext } from './ticket-builder-context';
import { PRODUCT_TYPE_HOSPITALITY } from '../../../general/js/basket/constants';

class TicketBuilderAside extends React.Component {
    constructor(props) {
        super(props);

        this.onContinue = this.onContinue.bind(this);
    }

    renderProduct(basketProduct) {
        if (!basketProduct) return null;

        const {
            id, title, quantity, price, sum, type
        } = basketProduct;

        const isHospitality = type === PRODUCT_TYPE_HOSPITALITY;

        if (!isHospitality && !quantity) return null;

        return (
            <div className="basket-item copy" key={id}>
                <div className="basket-item__title">{title}</div>

                {(isHospitality ? quantity !== undefined : true) && (
                    <div className="basket-item__quantity">x{quantity}</div>
                )}
                
                {(isHospitality ? sum !== undefined : true) && (
                    <div className="basket-item__price">
                        {price > 0 ? CurrencyHelper.convertToPounds(sum) : 'Free'}
                    </div>
                )}
            </div>
        );
    }

    renderProductGroups() {
        const preparedProductGroups = this.getPreparedProductGroups();

        if (preparedProductGroups.length === 0) {
            return this.renderEmpty();
        }

        return preparedProductGroups.map((basketProductGroup) => (
            <div className="basket-list" key={basketProductGroup.id}>
                <h3 className="basket-list__title copy">{basketProductGroup.title}</h3>
                {
                    basketProductGroup.products.sort((a, b) => a.sortOrder - b.sortOrder)
                        .map((basketProduct) => this.renderProduct(basketProduct))
                }
            </div>));
    }

    renderEmpty() {
        return (
            <div className="ticket-builder-aside__empty-wrap">
                <div className="ticket-builder-aside__empty-text">Your basket is empty</div>
            </div>
        );
    }

    getPreparedProductGroups() {
        const mergedWithTempGroups = { ...this.props.basket.productGroups };
        this.props.productGroupsList.forEach((productGroup) => {
            if (!(productGroup.id in mergedWithTempGroups)) {
                mergedWithTempGroups[productGroup.id] = productGroup;
            }
        });

        return Object.values(mergedWithTempGroups);
    }

    onContinue(actionCaption, fromRoute) {
        if (actionCaption === 'Pay') {
            const preparedProductGroups = this.getPreparedProductGroups();

            const basketValue = TrackingHelper.getBasketTotalValue(preparedProductGroups);
            const basketItems = TrackingHelper.getBasketProducts(preparedProductGroups);

            gtm.pushEcommerceEvent(ecommerceEventTypes.BEGIN_CHECKOUT, {
                currency: currencyIsoCodes.GBP,
                value: basketValue,
                items: basketItems
            });
        }
    }

    render() {
        return (
            <div className="ticket-builder-aside__wrapper">
                <div className="ticket-builder-aside">
                    <div className="ticket-builder-aside__main">
                        <button
                            className="ticket-builder-aside__toggle"
                            type="button"
                            onClick={() => this.props.onToggleBasketMobile()}
                        >
                            <svg className="ticket-builder-aside__chevron-icon icon"
                                width="11" height="7" focusable="false">
                                <use xlinkHref="#icon-chevron-up"></use>
                            </svg>
                        </button>
                        <div className="ticket-builder-aside__header">
                            <svg className="ticket-builder-aside__basket-icon icon"
                                width="16" height="16" focusable="false">
                                <use xlinkHref="#icon-basket"></use>
                            </svg>
                            <h2 className="ticket-builder-aside__heading">Your Basket</h2>
                            <a className="ticket-builder-aside__edit-link link"
                                href={this.props.basketUrl}
                                aria-label="Edit basket"
                                id="editBasket">Edit</a>
                        </div>
                        <div className="ticket-builder-aside__content">
                            {this.renderProductGroups()}
                        </div>
                    </div>
                    <div className="ticket-builder-aside__footer">
                        <div className="ticket-builder-aside__footer-line">
                            <span>Total</span>
                            <span
                                className="ticket-builder-aside__total">{CurrencyHelper.convertToPounds(this.props.basket.total)}</span>
                        </div>
                        {'totalMc' in this.props.basket ?
                            <div className="ticket-builder-aside__footer-line">
                                <span>Total with</span>
                                <span className="ticket-builder-aside__footer-mc"></span>
                                <span
                                    className="ticket-builder-aside__total">{CurrencyHelper.convertToPounds(this.props.basket.totalMc)}</span>
                            </div> :
                            null}
                        <div aria-live="polite">
                            {this.props.renderControls(this.onContinue)}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

TicketBuilderAside.propTypes = {
    productGroupsList: PropTypes.array,
    basket: PropTypes.object,
    onToggleBasketMobile: PropTypes.func,
    renderControls: PropTypes.func,
    tb: PropTypes.object.isRequired,
    basketUrl: PropTypes.string
};

export default withTicketBuilderContext(TicketBuilderAside);
